/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2023-2024 (c) Marc Fischer, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { Component } from 'react';

export class Home extends Component {
  static displayName = Home.name;

  render() {
    return (
      <div>
        <h1>Dashboard administration</h1>
      </div>
    );
  }
}
